<template>
    <div class="type_check_box no-trans" v-loading="loading">
        <el-dialog title="申请岗位" :visible.sync="dialogVisible" :close-on-click-modal="false" :close-on-press-escape="false" :before-close="handleClose">
            <div class="dialog_box">
                <div class="form_box">
                    <div class="form_title">
                        您的姓名：
                    </div>
                    <div class="form_input1">
                        <el-input v-model="form.name" placeholder="请输入内容"></el-input>
                    </div>
                </div>
                <div class="form_box">
                    <div class="form_title">
                        您的电话：
                    </div>
                    <div class="form_input1">
                        <el-input v-model="form.phone" placeholder="请输入内容"></el-input>
                    </div>
                </div>
                <div class="form_box">
                    <div class="form_title">
                        您的邮箱：
                    </div>
                    <div class="form_input1">
                        <el-input v-model="form.email" placeholder="请输入内容"></el-input>
                    </div>
                </div>
                <div class="form_box">
                    <div class="form_title">
                        简历附件：
                    </div>
                    <div class="form_input2">
                        <div class="btns_up" @click="handle_img_add">
                            上传附件
                            <img src="@/assets/img/index/talent_acquisition/shang.png" alt="">
                        </div>
                        <div class="file_list">
                            <div class="files_flex" v-for="(item,index) in file_list" :key="index">
                                <div class="files_text">{{ item.name }}</div>
                                <div class="files_clear" @click="handle_clear(index)">
                                    <img src="@/assets/img/index/comments_case/clear.png" alt="">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="btns_box">
                    <div class="btns1" @click="handleClose">取消</div>
                    <div class="btns2" @click="handle_end">提交</div>
                </div>
                
            </div>
        </el-dialog>
        <upload  v-show="false" ref="uploads" :show_type="true" :types="types"></upload>

    </div>
</template>
<script>
import {
    mapState
} from 'vuex'
import upload from '@/components/upload/upload.vue'

export default {
    components: {
        upload,

    },
    name: "homes",
    data() {
        return {
            types:JSON.stringify(['jpg','png','pdf','docx']),
            loading:false,
            dialogVisible:false,//显示隐藏
            form:{
                name:'',
                phone:'',
                email:'',
                file:'',
            },
            file_list:[],
        }
    },
    computed: {
       
    },
    watch: {

    },
    created() {

    },
    methods: {
        handleClose(){
            this.dialogVisible=false
        },
        
        handle_open(){
            this.dialogVisible=true
        },
        handle_end(){
            this.dialogVisible=false
           
        },
        //触发上传
        handle_img_add(text){
            let datas={
            }
            this.$refs.uploads.uploadFile(datas)
        },
        //上传图片
        upload_url(res_data,datas){
            this.file_list.push(res_data)
        },
        //删除图片
        handle_clear(index,text){
            this.file_list.splice(index,1)
        },
        handle_end(){
            if(!this.form.name){
                alertErr('请输入内容')
                return
            }
            if(!this.form.phone){
                alertErr('请输入电话')
                return
            }

            let reg = /^((11[0-9])|(12[0-9])|(13[0-9])|(14[0-9])|(15[0-9])|(16[0-9])|(17[0-9])|(18[0-9])|(19[0-9]))\d{8}$/;
            if (!reg.test(this.form.phone)) {
                alertErr('请输入正确的手机号')
                return 
            }
            if(!this.form.email){
                alertErr('请输入邮箱')
                return
            }
            if(this.file_list.length==0){
                alertErr('请上传附件')
                return
            }
            let file_list=[]
            this.file_list.forEach((e)=>{
                file_list.push(e.path)
            })
            this.form.file=file_list.join(',')
            this.loading=true
            this.$api("resume", {
                id: this.$route.query.id,
                ...this.form,
			}, "post").then((res) => {
                this.loading = false
                console.log('职位申请',res)
                if (res.code == 1) {
                    this.dialogVisible=false
                    this.form={
                        name:'',
                        phone:'',
                        email:'',
                        file:'',
                    }
                    this.file_list=[]
                } else {
                    alertErr(res.msg)
                }
            });

        },
       
      

    },

}
</script>
<style scoped lang="less">
.type_check_box {
    /deep/.el-dialog__wrapper{
        .el-dialog{
            width: 580px;
            .el-dialog__header{
                background: #F7F7F7;
            }
            .el-dialog__body{
                .dialog_box{
                    .form_box{
                        margin-bottom:20px;
                        .form_title{
                            margin-bottom: 14px;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 16px;
                            color: #6D6D6D;

                        }
                        .form_input1{
                            
                        }
                        .form_input2{
                            .btns_up{
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                width: 160px;
                                height: 44px;
                                border-radius: 24px 24px 24px 24px;
                                border: 1px solid #377CFD;
                                cursor: pointer;
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 14px;
                                color: #377CFD;

                                img{
                                    width: 5px;
                                    margin-left: 27px;
                                }
                            }
                            .file_list{
                               margin-top: 20px; 
                               .files_flex{
                                    width: 513px;
                                    height: 40px;
                                    background: #F8F8F8;
                                    border-radius: 0px 0px 0px 0px;
                                    display: flex;
                                    align-items: center;
                                    justify-content: space-between;
                                    padding: 0 21px;
                                    margin-bottom: 10px;
                                    .files_text{
                                        font-family: Microsoft YaHei, Microsoft YaHei;
                                        font-weight: 400;
                                        font-size: 14px;
                                        color: #6D6D6D;
                                        overflow: hidden;
                                        text-overflow: ellipsis;
                                        display: -webkit-box;
                                        -webkit-line-clamp: 1;
                                        -webkit-box-orient: vertical;

                                    }
                                    .files_clear{
                                        cursor: pointer;
                                        img{
                                           width: 16px; 
                                        }
                                    }
                               }
                            }
                        }
                    }
                    .btns_box{
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        .btns1{
                            width: 160px;
                            height: 44px;
                            border-radius: 24px 24px 24px 24px;
                            border: 1px solid #377CFD;
                            margin-right: 20px;
                            cursor: pointer;
                            text-align: center;
                            line-height: 44px;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #377CFD;

                        }
                        .btns2{
                            width: 160px;
                            height: 44px;
                            background: #377CFD;
                            text-align: center;
                            border-radius: 24px 24px 24px 24px;
                            line-height: 44px;
                            cursor: pointer;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #FFFFFF;


                        }
                    }
                     
                }
            }
        }
    }
}
</style>
<style scoped lang="less">
@media (max-width: 1024px) {
    .type_check_box.no-trans {
        max-width: 100%;
        min-width: 0;
        font-size: 14px;
        line-height: 1.6;
    }
    .type_check_box.no-trans /deep/ .el-dialog__wrapper .el-dialog {
        max-width: 100%;
        min-width: 0;
        width: 100%;
    }
    .type_check_box.no-trans /deep/ .el-dialog__wrapper .el-dialog .el-dialog__body .dialog_box .form_box {
        margin-bottom: 16px;
    }
    .type_check_box.no-trans /deep/ .el-dialog__wrapper .el-dialog .el-dialog__body .dialog_box .form_box .form_title {
        margin-bottom: 14px;
        font-size: 16px;
        width: 100%;
        text-align: left;
        line-height: 1.6;
        padding: 0;
    }
    .type_check_box.no-trans /deep/ .el-dialog__wrapper .el-dialog .el-dialog__body .dialog_box .form_box .form_input2 .btns_up {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        max-width: 100%;
        width: 100%;
        height: auto;
        border-radius: 8px 8px 8px 8px;
        font-size: 14px;
        min-height: 44px;
    }
    .type_check_box.no-trans /deep/ .el-dialog__wrapper .el-dialog .el-dialog__body .dialog_box .form_box .form_input2 .btns_up img {
        width: 5px;
        margin-left: 16px;
    }
    .type_check_box.no-trans /deep/ .el-dialog__wrapper .el-dialog .el-dialog__body .dialog_box .form_box .form_input2 .file_list {
        margin-top: 16px;
    }
    .type_check_box.no-trans /deep/ .el-dialog__wrapper .el-dialog .el-dialog__body .dialog_box .form_box .form_input2 .file_list .files_flex {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        height: auto;
        border-radius: 0px 0px 0px 0px;
        flex-wrap: wrap;
        gap: 8px;
        padding: 0 16px;
        margin-bottom: 10px;
        min-height: 40px;
    }
    .type_check_box.no-trans /deep/ .el-dialog__wrapper .el-dialog .el-dialog__body .dialog_box .form_box .form_input2 .file_list .files_flex .files_text {
        font-size: 14px;
    }
    .type_check_box.no-trans /deep/ .el-dialog__wrapper .el-dialog .el-dialog__body .dialog_box .form_box .form_input2 .file_list .files_flex .files_clear img {
        width: 16px;
    }
    .type_check_box.no-trans /deep/ .el-dialog__wrapper .el-dialog .el-dialog__body .dialog_box .btns_box {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .type_check_box.no-trans /deep/ .el-dialog__wrapper .el-dialog .el-dialog__body .dialog_box .btns_box .btns1 {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        height: auto;
        border-radius: 8px 8px 8px 8px;
        margin-right: 16px;
        line-height: 1.6;
        font-size: 14px;
        min-height: 44px;
        padding-top: 12px;
        padding-bottom: 12px;
    }
    .type_check_box.no-trans /deep/ .el-dialog__wrapper .el-dialog .el-dialog__body .dialog_box .btns_box .btns2 {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        height: auto;
        border-radius: 8px 8px 8px 8px;
        line-height: 1.6;
        font-size: 14px;
        min-height: 44px;
        padding-top: 12px;
        padding-bottom: 12px;
    }
}
</style>
